// src/components/WidgetWrapper.jsx
import React from 'react';
import { WidgetProvider, Widget } from '@rango-dev/widget-embedded';
import { widgetConfig } from 'config/widgetConfig';

const WidgetWrapper = () => {
  return (
    <WidgetProvider config={widgetConfig}>
      <Widget config={widgetConfig} />
    </WidgetProvider>
  );
};

export default WidgetWrapper;
